/**
 * Runtime platform checks.
 *
 * Tauri v2 injects `__TAURI_INTERNALS__` into the webview, which is a reliable
 * runtime signal — unlike build-time env vars, it also works when the same bundle
 * is loaded by the Tauri dev server and by a browser.
 */
export const isTauri = (): boolean =>
  typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;

/** True on the Tauri mobile targets, where safe-area insets matter. */
export const isTauriMobile = (): boolean =>
  isTauri() && /android|iphone|ipad/i.test(navigator.userAgent);

/**
 * True in the flying-note window.
 *
 * Keyed off the route rather than the Tauri window label so the same screen can
 * be opened in a browser tab during development, and so nothing depends on the
 * shape of Tauri's injected internals. Kept in sync with the pre-paint check in
 * `index.html`, which adds `.quick-window` before first paint so the
 * transparent window never flashes an opaque background.
 */
export const isQuickCaptureWindow = (): boolean =>
  typeof window !== "undefined" && window.location.hash.replace(/^#/, "").startsWith("/quick");
